const TONE_CLASSES = {
  neutral: 'bg-surface-elevated text-content-secondary',
  warning: 'bg-amber-500/15 text-amber-500',
};

/**
 * Tag chip for the Inbox list rows (aims-htl wq-inbox-item).
 *
 * Not the `@aimsos/ui` Badge on purpose: every Badge variant is bordered, and
 * the prototype rows stack borderless tinted chips so the card edge stays the
 * only visible outline. `className` takes a severity token from SEVERITY_META.
 *
 * `shrinkable` chips give up width instead of wrapping the row onto a second
 * line, which would make the card taller than its siblings.
 */
function InboxChip({ children, tone = 'neutral', className = '', shrinkable = false }) {
  return (
    <span
      className={[
        'inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-medium leading-none',
        shrinkable ? 'min-w-0' : 'shrink-0 whitespace-nowrap',
        className || TONE_CLASSES[tone] || TONE_CLASSES.neutral,
      ].join(' ')}
    >
      {children}
    </span>
  );
}

export default InboxChip;
